import script from "./SourceList.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceList.vue?vue&type=script&setup=true&lang=js"

import "./SourceList.vue?vue&type=style&index=0&id=2173df97&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2173df97"]])

export default __exports__